
import i18n from "i18next";
import Backend from "i18next-fs-backend";
import enTranslations from "locales/en/translations.json";
import arTranslations from "locales/ar/translations.json";
import bnTranslations from "locales/bn/translations.json";
import fiTranslations from 'locales/fi/translations.json';

export const localesMapping = {
  "en": {
    translations: enTranslations,
  },
  "ar": {
    translations: arTranslations,
  },
  "bn": {
    translations: bnTranslations,
  },
  "fi": {
    translations: fiTranslations,
  }
};

export const initialize = (lang, opts = {}) => {
  const defaultLang = "en"
  const config = {
    lng: (lang || defaultLang).toLowerCase(),
    fallbackLng: defaultLang,
    resources: localesMapping,
    ns: ["translations"],
    defaultNS: "translations",
    interpolation: {
      escapeValue: false
    },
    initImmediate: false,
    react: {
      wait: true,
      bindI18n: "languageChanged loaded",
      bindStore: "added removed"
    },
    lowerCaseLng: true
  };

  const throwOnMissingKeyConfig = {
    saveMissing: true,
    missingKeyHandler: function(lng, ns, key, fallbackValue) {
      throw new Error("[I18n] missing base translation for key: " + key);
    }
  };

  i18n
    .use(Backend)
    .init(Object.assign(config, opts.throwOnMissingKey && throwOnMissingKeyConfig));
  
  return i18n;
};

export const t = (...args) => {
  if (!i18n.t) {
    throw new Error("[I18n] translate function called on an uninitialized instance!");
  }
  return i18n.t.apply(i18n, args);
};

export default t;



// WEBPACK FOOTER //
// ./app/javascript/i18n.js